import React from "react";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";
import SurveyNameComponent from "../Elements/SurveyNameComponent";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import dateTimeHelper from "../Helpers/datetimeHelper";
import JsxHelper from "../Helpers/JsxHelper";

export default class CaspianXxApiClientAndSurveyIdPairItem {
  constructor(item) {
    if (item === undefined) {
      this.Id = "";
      this.ClientSassieId = "";
      this.SurveySassieId = "";
      this.Option1 = "";
      this.StartDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.EndDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addMonthsToDate(new Date(), 6));
      this.IsActive = "true";
      this.LastSentOn = "";
      this.CreatedOn = "";
      this.CreatedBy = "";
      this.ModifiedOn = "";
      this.ModifiedBy = "";
      this.Selected = false;
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.Id = item.id;
    this.ClientSassieId = item.clientSassieId;
    this.SurveySassieId = item.surveySassieId;
    this.Option1 = item.option1;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.IsActive = item.isActive;
    this.LastSentOn = item.lastSentOn;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.Selected = false;
  }

  static NameOfTheIdField() {
    return "Id";
  }
  static nameOfTheItemDetailList() {
    return "CaspianXx Api Client And Survey Id Pair";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = ["StartDate", "EndDate", "LastSentOn", "CreatedOn", "ModifiedOn"];

  static BoolFields = ["IsActive"];

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [
        { name: "Id", label: "id" },
        { name: "ClientSassieId", label: "Client Sassie Id" },
        { name: "SurveySassieId", label: "Survey Sassie Id" },
        { name: (item) => <SurveyNameComponent surveyId={item.SurveySassieId} />, label: "Survey" },
        { name: "Option1", label: "Option1" },
        { name: "StartDate", label: "Start Date" },
        { name: "EndDate", label: "End Date" },
        { name: "IsActive", label: "Is Active" },
        { name: "LastSentOn", label: "Last Sent On" },
        { name: "CreatedOn", label: "Created On" },
        { name: "CreatedBy", label: "Created By" },
        { name: "ModifiedOn", label: "Modified On" },
        { name: "ModifiedBy", label: "Modified By" },
      ],
    },
  ];

  // //Meaning of data field:
  // //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  // //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  // //			and the field shows the result of this function
  // //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  // static FieldsToShowInDataTable() {
  //   return [
  //     { label: "Id", orderById: "Id", data: "Id", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
  //     { label: "Client Sassie Id", orderById: "ClientSassieId", data: "ClientSassieId" },
  //     { label: "Survey Name (Id)", orderById: "SurveySassieId", data: item => <SurveyNameComponent surveyId={item.SurveySassieId} />, minWidth: 50 },
  //     { label: "Option1", orderById: "Option1", data: "Option1", minWidth: 50 },
  //     { label: "Start Date", orderById: "StartDate", data: "StartDate", minWidth: 50 },
  //     { label: "End Date", orderById: "EndDate", data: "EndDate", minWidth: 50 },
  //     { label: "Last Sent On", orderById: "LastSentOn", data: "LastSentOn", type: FieldTypesEnum.Email, minWidth: 50 },
  //     { label: "Is Active", orderById: "IsActive", data: item => JsxHelper.YesNo(item.IsActive) },
  //     { label: " ", orderById: "", data: CaspianXxApiClientAndSurveyIdPairItem.getActionsContent, type: FieldTypesEnum.ActionButton },
  //   ];
  // }

  // static getActionsContent(item) {
  //   return (
  //     <DataTableActionMenu
  //       options={[
  //         {
  //           iconName: "fa-solid fa-edit",
  //           onClick: () => CaspianXxApiClientAndSurveyIdPairItem.editFunction(item.Id, item),
  //           text: "Edit",
  //           tooltipText: "Edit",
  //         },
  //       ]}
  //     />
  //   );
  // }

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [
        { name: "Id", label: "id" },
        { name: "ClientSassieId", label: "Client Sassie Id" },
        { name: "SurveySassieId", label: "Survey Sassie Id" },
        { name: (item) => <SurveyNameComponent surveyId={item.SurveySassieId} />, label: "Survey" },
        { name: "Option1", label: "Option1" },
        { name: "StartDate", label: "Start Date" },
        { name: "EndDate", label: "End Date" },
        { name: "IsActive", label: "Is Active" },
        { name: "LastSentOn", label: "Last Sent On" },
        { name: "CreatedOn", label: "Created On" },
        { name: "CreatedBy", label: "Created By" },
        { name: "ModifiedOn", label: "Modified On" },
        { name: "ModifiedBy", label: "Modified By" },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: CaspianXxApiClientAndSurveyIdPairItem.getSelectedCellHeader,
        orderById: "",
        data: CaspianXxApiClientAndSurveyIdPairItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
        rolekey: "caspianxx_clientsurveyidpairselect",
      },
      { label: "Id", orderById: "Id", data: "Id", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: "Client Sassie Id", orderById: "ClientSassieId", data: "ClientSassieId", type: FieldTypesEnum.PureDataField },
      { label: "Survey Name (Id)", orderById: "SurveySassieId", data: (item) => <SurveyNameComponent surveyId={item.SurveySassieId} />, type: FieldTypesEnum.PureDataField, minWidth: 50 },
      { label: "Option1", orderById: "Option1", data: "Option1", type: FieldTypesEnum.PureDataField, minWidth: 50 },
      { label: "Start Date", orderById: "StartDate", data: "StartDate", type: FieldTypesEnum.PureDataField, minWidth: 50 },
      { label: "End Date", orderById: "EndDate", data: "EndDate", type: FieldTypesEnum.PureDataField, minWidth: 50 },
      { label: "Last Sent On", orderById: "LastSentOn", data: "LastSentOn", type: FieldTypesEnum.Email, minWidth: 50 },
      { label: "Is Active", orderById: "IsActive", data: (item) => JsxHelper.YesNo(item.IsActive), type: FieldTypesEnum.PureDataField },
      { label: " ", orderById: "", data: CaspianXxApiClientAndSurveyIdPairItem.getActionsContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type="checkbox"
          checked={CaspianXxApiClientAndSurveyIdPairItem.selectedStatus()}
          onChange={(e) => {
            CaspianXxApiClientAndSurveyIdPairItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: "fa-solid fa-edit",
            onClick: () => CaspianXxApiClientAndSurveyIdPairItem.editFunction(item.Id, item),
            text: "Edit",
            tooltipText: "Edit",
          },
        ]}
      />
    );
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }

  static getSelectedCellContent(item) {
    return (
      <div className="text-center">
        <input
          type="checkbox"
          checked={item.Selected}
          onChange={(e) => {
            CaspianXxApiClientAndSurveyIdPairItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }
}
